/** Public traveller content only. Audit metadata is deliberately left intact. */
export function essentialUsefulInfoText(input: unknown): string {
  if (typeof input !== "string") return "";
  return input.replace(/\r\n?/g, "\n").split("\n").filter(line =>
    !/^\s*(?:fonte(?:\s+ufficiale)?|fonti(?:\s+ufficiali)?|official\s+source|sources?|fuentes?(?:\s+oficial(?:es)?)?|verificat[oa]|checked|consultad[oa]|last\s+verified|ultimo\s+aggiornamento|fecha\s+de\s+verificaci[oó]n)(?:\s*[:·–—-]|\s+(?:il|on|el|e verifica|and verification)|\s*$)/i.test(line)
  ).map(line => line.replace(/https?:\/\/[^\s<>]+|\bwww\.[^\s<>]+/gi, "")
    .replace(/(?:Contatti e competenze nella fonte\.|See the source for contacts and jurisdiction\.|Contactos y competencias en la fuente\.)/gi, "")
    .replace(/verifica la fonte ufficiale/gi, "verifica con le autorità competenti")
    .replace(/check the official source/gi, "check with the relevant authorities")
    .replace(/verifica la fuente oficial/gi, "consulta a las autoridades competentes")
    .replace(/La fonte segnala anche/gi, "È segnalata anche").replace(/The source also reports/gi, "There are also reports of").replace(/La fuente también señala/gi, "También se señala")
    .trim()).join("\n").replace(/\n{3,}/g, "\n\n").trim();
}

/** Only addresses present in the content are used; never guess a diplomatic location. */
export function usefulInfoMapLocations(field: string, text: string): Array<{ address: string; url: string }> {
  if (field !== "embassy" && field !== "consulates") return [];
  const addresses = essentialUsefulInfoText(text).split("\n").map(x => x.trim()).filter(line =>
    /\d/.test(line) && /\b(?:road|street|avenue|rue|via|viale|piazza|calle|avenida|platz|strasse|straße|gasse|weg|square|boulevard)\b|(?:gasse|straße|strasse|weg)\s+\d/i.test(line)
    && !/@|\+\d|https?:|tel\b|phone|telefono/i.test(line)
  );
  return [...new Set(addresses)].map(address => ({ address, url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}` }));
}

export function usefulInfoMapsLabel(language: string): string {
  return language === "it" ? "Apri in Google Maps" : language === "es" ? "Abrir en Google Maps" : "Open in Google Maps";
}
